const INITIAL_STATE = {
  storageAddressTypesList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_STORAGE_ADRESS_TYPES': {
      return { ...state, storageAddressTypesList: action.storageAddressTypes };
    }
    default:
      return state;
  }
};
